export function accordion() {
    document.querySelectorAll('[data-accordion-init]').forEach((accordion) => {
        const closeSiblings =
            accordion.getAttribute('data-accordion-close-siblings') === 'true';

        accordion.addEventListener('click', (event) => {
            const toggle = event.target.closest('[data-accordion-toggle]');
            if (!toggle) return;

            const item = toggle.closest('[data-accordion-status]');
            if (!item) return;

            const isActive =
                item.getAttribute('data-accordion-status') === 'active';

            item.setAttribute(
                'data-accordion-status',
                isActive ? 'not-active' : 'active'
            );
            toggle.setAttribute('aria-expanded', String(!isActive));

            if (closeSiblings && !isActive) {
                accordion
                    .querySelectorAll('[data-accordion-status="active"]')
                    .forEach((sibling) => {
                        if (sibling !== item) {
                            sibling.setAttribute(
                                'data-accordion-status',
                                'not-active'
                            );
                            sibling
                                .querySelector('[data-accordion-toggle]')
                                ?.setAttribute('aria-expanded', 'false');
                        }
                    });
            }
        });
    });
}
